







































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { insuranceService } from '@/services/InsuranceService';
import CollapseCard from '@/components/layout/CollapseCard.vue';
import {
  Button,
  Radio,
  Card,
  Form,
  FormItem,
  Input,
  InputNumber,
  Select,
  Option,
  Autocomplete,
  DatePicker,
  Checkbox
} from 'element-ui';
import { portService } from '@/services/PortService';
import {
  calculateInsurance_calculateInsurance,
  tokioMarineContracts_tokioMarineContracts,
  PlaceFields,
  TransportationTypeEnum,
  CustomerRoleEnum,
  fetchShipmentForInsurance_shipments,
  MilestoneTypeEnum
} from '@/types/graphql/schemaTypes';
import format from 'date-fns/format';
import { TranslateResult } from 'vue-i18n';

@Component({
  components: {
    CollapseCard,
    'el-button': Button,
    'el-radio': Radio,
    'el-card': Card,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-input-number': InputNumber,
    'el-select': Select,
    'el-option': Option,
    'el-checkbox': Checkbox,
    'el-autocomplete': Autocomplete,
    'el-date-picker': DatePicker
  }
})
export default class InsuranceForm extends Vue {
  @Prop({ required: true, type: Object })
  public shipment!: fetchShipmentForInsurance_shipments;

  @Prop({ required: true, type: Array })
  public contracts!: tokioMarineContracts_tokioMarineContracts[];

  private result: calculateInsurance_calculateInsurance | null = null;
  private visibleFlags = {
    extraDocument: false,
    tariff: false,
    lc: false,
    otherMessage: false,
    remarks: false,
    extra: false
  };

  private contractNumber = '';

  // Assured Info
  private assuredFromSettings = false;
  private assured: string[] = Array(3).fill('');
  private invoices: string[] = Array(3).fill('');

  private documents = [{ type: '', number: '' }, { type: '', number: '' }];

  // Route info
  private transportationType: TransportationTypeEnum =
    TransportationTypeEnum.sea;

  private mainTransportationType = '01';

  private departureSearch = '';
  @Watch('departureSearch')
  private prefixDepartureSearch() {
    const contract = this.currentContract;
    if (
      contract &&
      contract.yushutsunyuDiv === '1' &&
      !this.departureSearch.startsWith('JP') // Export case, departure should be Japan
    ) {
      this.departureSearch = 'JP';
    }
  }

  private departurePort: PlaceFields | null = null;

  private arrivalSearch = '';
  @Watch('arrivalSearch')
  private prefixArrivalSearch() {
    const contract = this.currentContract;
    if (
      contract &&
      contract.yushutsunyuDiv === '2' && // Import case, arrival should be Japan
      !this.arrivalSearch.startsWith('JP')
    ) {
      this.arrivalSearch = 'JP';
    }
  }

  private arrivalPort: PlaceFields | null = null;
  private etd = '';
  private vesselName = '';
  private voyageNo = '';
  private isTransShip = false;
  private transShip = '';
  private transShipTransportationType = '';
  private transShipPort = '';

  // Departure segment
  private hasDepartureTransport = true;
  private departurePlaceType = '1';
  private departureCountryCode = '';
  private departureCity = '';
  private sameCountryAsDeparturePort = true;
  private departureTransportationType = '';

  // Arrival Segment
  private hasArrivalTransport = true;
  private arrivalPlaceType = '1';
  private arrivalCountryCode = '';
  private arrivalCity = '';
  private sameCountryAsArrivalPort = true;
  private arrivalTransportationType = '';

  // Cargo
  private hsCode = '';
  private cargoDescription = '??? CTS (??? KGS)  OF  IN CONTAINER';
  private cargoQuantity = '';

  // Commercial Invoice
  private priceType = '1';
  private invoiceCurrency = '\\';
  private invoiceValue = '';
  private invoiceCurrencyConversionMode = 'date';
  private invoiceCurrencyDate = '';
  private invoiceCurrencyRate = '';

  // Insurance
  private insurancePaymentPlaceType = '1';
  private insurancePaymentPlaceName = '';
  private insuranceCurrency = '\\';
  private insuranceValue = '';

  // Freight
  private freightCurrency = 'US$';
  private freightValue = '';
  private freightCurrencyConversionMode = 'date';
  private freightCurrencyDate = '';
  private freightCurrencyRate = '';

  private get freightEnabled() {
    if (this.priceType === '4') {
      return false;
    }

    const contract = this.currentContract;
    if (!contract) {
      return true;
    }

    return (contract.yushutsunyuDiv === '1' && this.priceType !== '1') || // Export can't be fob
      (contract.yushutsunyuDiv === '2' && this.priceType === '1'); // Import has to be fob
  }

  // Policy
  private get policyType() {
    const contract = this.currentContract;
    return contract ? contract.shokenRuiDiv : '3';
  }

  private policyIssueDate = format(new Date(), 'yyyyMMdd');
  private policyNumberOfOriginals = 0;
  private policyNumberOfCopies = 0;

  // Debit note
  private debitNoteNetNumberOfOriginals = 1;
  private debitNoteNetNumberOfCopies = 0;
  private debitNoteGrossNumberOfOriginals = 1;
  private debitNoteGrossNumberOfCopies = 0;

  // Customs
  private tariffRate = '';
  private customsInsuranceCurrency = '\\';
  private customsInsuranceAmount = '';

  // Remarks
  private refCodes: string[] = Array(2).fill('');
  private remarks: string[] = Array(5).fill('');
  private otherMessage = '';
  private lcConditions = '';

  mounted() {
    this.$emit('ready');
  }

  @Watch('shipment', { immediate: true })
  private setValues(shipment: fetchShipmentForInsurance_shipments) {
    if (!shipment) {
      return;
    }

    if (shipment.departurePlace) {
      this.departurePort = shipment.departurePlace;
      this.departureSearch = this.generatePortOptionLabel(
        shipment.departurePlace
      );
    }

    if (shipment.arrivalPlace) {
      this.arrivalPort = shipment.arrivalPlace;
      this.arrivalSearch = this.generatePortOptionLabel(shipment.arrivalPlace);
    }

    this.invoices[0] = shipment.invoiceNumber || '';

    if (shipment.blMetaData && shipment.blMetaData.blNumber) {
      this.documents[0].number = shipment.blMetaData.blNumber;
      this.documents[0].type = '2';
    }

    const seaMilestone = (shipment.milestones || []).reverse().find((milestone) => {
      return milestone.milestoneType === MilestoneTypeEnum.sea_transportation;
    });

    if (seaMilestone) {
      this.voyageNo = (seaMilestone.details && seaMilestone.details.voyageNumber) || '';
      this.vesselName = (seaMilestone.vessel && seaMilestone.vessel.name) || '';

      if (seaMilestone.estimatedDateOfDeparture) {
        this.etd = format(new Date(seaMilestone.estimatedDateOfDeparture), 'yyyyMMdd');
      }
    }

    this.refCodes[0] = shipment.id;
    this.refCodes[1] = shipment.reference || '';
  }

  private get currentContract() {
    return this.contracts.find(c => c.tsuuchiFormNo === this.contractNumber);
  }

  @Watch('currentContract')
  private onCurrentContractChange(
    currentContract?: tokioMarineContracts_tokioMarineContracts
  ) {
    if (!currentContract) {
      return;
    }
    if (currentContract.yushutsunyuDiv === '1') {
      this.departureCountryCode = 'JP';
    }
    if (currentContract.yushutsunyuDiv === '2') {
      this.arrivalCountryCode = 'JP';
    }
  }

  private get contractData() {
    const contract = this.currentContract;
    if (!contract) {
      return {};
    }

    return {
      tsuuchiFormNo: contract.tsuuchiFormNo,
      yushutsunyuDiv: contract.yushutsunyuDiv,
      kamotsuShuruiSentakuFlg: contract.kamotsuShuruiSentakuFlg
    };
  }

  private set contractData(data) {
    this.contractNumber = data.tsuuchiFormNo;
  }

  private get assuredDataForSaving() {
    const res = {
      assuredRiyoDiv: this.assuredFromSettings ? '2' : '1',
      invoiceNo1: this.invoices[0] || '',
      invoiceNo2: this.invoices[1] || '',
      invoiceNo3: this.invoices[2] || '',
      keyCdDiv1: this.documents[0]?.type,
      keyCdNo1: this.documents[0]?.number,
      keyCdDiv2: this.documents[1]?.type,
      keyCdNo2: this.documents[1]?.number
    };
    return this.assuredFromSettings
      ? res
      : {
        ...res,
        assured1: this.assured[0] || '',
        assured2: this.assured[1] || '',
        assured3: this.assured[2] || ''
      };
  }

  private get assuredData() {
    const res = {
      assuredRiyoDiv: this.assuredFromSettings ? '2' : '1',
      invoiceNo1: this.invoices[0] || '',
      invoiceNo2: this.invoices[1] || '',
      invoiceNo3: this.invoices[2] || '',
      keyCdDiv1: this.documents[0].type,
      keyCdNo1: this.documents[0].number,
      keyCdDiv2: this.documents[1].type,
      keyCdNo2: this.documents[1].number
    };
    return this.assuredFromSettings
      ? res
      : {
        ...res,
        assured1: this.assured[0] || '',
        assured2: this.assured[1] || '',
        assured3: this.assured[2] || ''
      };
  }

  private set assuredData(data) {
    // Set the assuredFromSettings value
    this.assuredFromSettings = !(data as any).assured1;
    this.invoices[0] = data.invoiceNo1 ? data.invoiceNo1 : null;
    this.invoices[1] = data.invoiceNo2 ? data.invoiceNo2 : null;
    this.invoices[2] = data.invoiceNo3 ? data.invoiceNo3 : null;
    this.documents[0] = {
      number: data.keyCdNo1,
      type: data.keyCdDiv1
    };
    this.documents[1] = {
      number: data.keyCdNo2,
      type: data.keyCdDiv2
    };
    this.assured[0] = (data as any).assured1 || '';
    this.assured[1] = (data as any).assured2 || '';
    this.assured[2] = (data as any).assured3 || '';
  }

  private get routeDataForSaving() {
    return {
      shutaruYusoYoguDiv: this.mainTransportationType,
      tsumikomikoKuniCd: this.departurePort?.countryCode,
      tsumikomikoToshimei: this.departurePort?.normalizedName,
      nioroshikoKuniCd: this.arrivalPort?.countryCode,
      nioroshikoToshimei: this.arrivalPort?.normalizedName,
      shuppanbiFrom: this.etd,
      honsen: this.vesselName,
      voyageNo: this.voyageNo,
      tsumikaechi: this.isTransShip.toString(),
      tsumikaeYusoyogu: this.isTransShip ? this.transShipTransportationType : ''
    };
  }

  private get routeData() {
    if (!this.departurePort || !this.arrivalPort) {
      return {};
    }
    return {
      shutaruYusoYoguDiv: this.mainTransportationType,
      tsumikomikoKuniCd: this.departurePort.countryCode,
      tsumikomikoToshimei: this.departurePort.normalizedName,
      nioroshikoKuniCd: this.arrivalPort.countryCode,
      nioroshikoToshimei: this.arrivalPort.normalizedName,
      shuppanbiFrom: this.etd,
      honsen: this.vesselName,
      voyageNo: this.voyageNo,
      tsumikaechi: this.isTransShip ? this.transShip : '',
      tsumikaeYusoyogu: this.isTransShip ? this.transShipTransportationType : ''
    };
  }

  private set routeData(data) {
    this.mainTransportationType = data.shutaruYusoYoguDiv;
    if (this.departurePort) {
      this.departurePort.countryCode = data.tsumikomikoKuniCd;
      this.departurePort.normalizedName = data.tsumikomikoToshimei;
    }
    if (this.arrivalPort) {
      this.arrivalPort.countryCode = data.nioroshikoKuniCd;
      this.arrivalPort.normalizedName = data.nioroshikoToshimei;
    }
    this.etd = data.shuppanbiFrom;
    this.vesselName = data.honsen;
    this.voyageNo = data.voyageNo;
    this.isTransShip = (data.tsumikaechi === 'true');
    this.transShipTransportationType = data.tsumikaeYusoyogu;
  }

  private get departureSegmentData() {
    if (!this.hasDepartureTransport) {
      return {
        okuchiShidashichiSetteiPtn: '5'
      };
    }

    return {
      okuchiShidashichiSetteiPtn: this.sameCountryAsDeparturePort ? '2' : '4',
      okuchiShidashichiKuniCd: this.sameCountryAsDeparturePort && this.departurePort
        ? this.departurePort.countryCode : this.departureCountryCode,
      okuchiShidashichiToshimei: this.departureCity,
      shidashichiYusoyogu: this.departureTransportationType,
      okuchiShidashichiSettogo: this.departurePlaceType
    };
  }

  private set departureSegmentData(data) {
    this.hasDepartureTransport = data.okuchiShidashichiSetteiPtn !== '5';
    this.sameCountryAsDeparturePort = data.okuchiShidashichiSetteiPtn === '2';

    const countryBool = this.sameCountryAsDeparturePort && this.departurePort;

    if (this.departurePort) {
      this.departurePort.countryCode = countryBool ? data.okuchiShidashichiKuniCd : null;
    }
    this.departureCountryCode = !countryBool ? data.okuchiShidashichiKuniCd : null;
    this.departureCity = data.okuchiShidashichiToshimei;
    this.departureTransportationType = data.shidashichiYusoyogu;
    this.departurePlaceType = data.okuchiShidashichiSettogo;
  }

  private get arrivalSegmentData() {
    if (!this.hasArrivalTransport) {
      return {
        saishuShimukechiSetteiPtn: '5'
      };
    }

    return {
      saishuShimukechiSetteiPtn: this.sameCountryAsArrivalPort ? '2' : '4',
      saishuShimukechiKuniCd: this.sameCountryAsArrivalPort && this.arrivalPort
        ? this.arrivalPort.countryCode : this.arrivalCountryCode,
      saishuShimukechiToshimei: this.arrivalCity,
      shimukechiYusoyogu: this.arrivalTransportationType,
      saishuShimukechiSettogo: this.arrivalPlaceType
    };
  }

  private set arrivalSegmentData(data) {
    this.hasArrivalTransport = data.saishuShimukechiSetteiPtn !== '5';
    this.sameCountryAsArrivalPort = data.saishuShimukechiSetteiPtn === '2';

    const countryBool = this.sameCountryAsArrivalPort && this.arrivalPort;

    if (this.arrivalPort) {
      this.arrivalPort.countryCode = countryBool ? data.saishuShimukechiKuniCd : null;
    }
    this.arrivalCountryCode = !countryBool ? data.saishuShimukechiKuniCd : null;
    this.arrivalCity = data.saishuShimukechiToshimei;
    this.arrivalTransportationType = data.shimukechiYusoyogu;
    this.arrivalPlaceType = data.saishuShimukechiSettogo;
  }

  private get cargoData() {
    const res: any = {
      hsCd: this.hsCode,
      quantity: this.cargoQuantity
    };

    const cargoDescriptionLines = this.cargoDescription.split(/\r\n|\r|\n/g);
    for (let i = 0; i < Math.min(cargoDescriptionLines.length, 7); i += 1) {
      res[`kamotsumeisai${i + 1}`] = cargoDescriptionLines[i] || '';
    }

    return res;
  }

  private set cargoData(data) {
    this.hsCode = data.hsCd;
    this.cargoQuantity = data.quantity;
    const cargoDescriptionLines = [];
    let description = '';
    if (data.kamotsumeisai1 !== null && data.kamotsumeisai1 !== undefined) {
      description += `${data.kamotsumeisai1}\r\n`;
    }
    if (data.kamotsumeisai2 !== null && data.kamotsumeisai2 !== undefined) {
      description += `${data.kamotsumeisai2}\r\n`;
    }
    if (data.kamotsumeisai3 !== null && data.kamotsumeisai3 !== undefined) {
      description += `${data.kamotsumeisai3}\r\n`;
    }
    if (data.kamotsumeisai4 !== null && data.kamotsumeisai4 !== undefined) {
      description += `${data.kamotsumeisai4}\r\n`;
    }
    if (data.kamotsumeisai5 !== null && data.kamotsumeisai5 !== undefined) {
      description += `${data.kamotsumeisai5}\r\n`;
    }
    if (data.kamotsumeisai6 !== null && data.kamotsumeisai6 !== undefined) {
      description += `${data.kamotsumeisai6}\r\n`;
    }
    if (data.kamotsumeisai7 !== null && data.kamotsumeisai7 !== undefined) {
      description += `${data.kamotsumeisai7}\r\n`;
    }
    this.cargoDescription = description;
  }

  private get invoiceData() {
    return {
      tateneHoushiki: this.priceType,
      invoiceCursn: this.invoiceCurrency,
      invoiceKingaku: this.invoiceValue,
      invoiceKanzanShiteiDiv:
        this.invoiceCurrencyConversionMode === 'date' ? '0' : '1',
      invoiceKanzanDay: this.invoiceCurrencyDate,
      invoiceKanzanRitsu: this.invoiceCurrencyRate
    };
  }

  private set invoiceData(data) {
    this.priceType = data.tateneHoushiki;
    this.invoiceCurrency = data.invoiceCursn;
    this.invoiceValue = data.invoiceKingaku;
    this.invoiceCurrencyConversionMode = data.invoiceKanzanShiteiDiv === '0' ? 'date' : 'rate';
    this.invoiceCurrencyDate = data.invoiceKanzanDay;
    this.invoiceCurrencyRate = data.invoiceKanzanRitsu;
  }

  private get insuranceData() {
    return {
      hokenKinShiharaichiDiv: this.insurancePaymentPlaceType,
      hokenKinShiharaichimei: this.insurancePaymentPlaceName,
      hokenKingakuCursn: this.insuranceCurrency,
      hokenKingaku: this.insuranceValue
    };
  }

  private set insuranceData(data) {
    this.insurancePaymentPlaceType = data.hokenKinShiharaichiDiv;
    this.insurancePaymentPlaceName = data.hokenKinShiharaichimei;
    this.insuranceCurrency = data.hokenKingakuCursn;
    this.insuranceValue = data.hokenKingaku;
  }

  private get freightData() {
    if (!this.freightEnabled) {
      return {
        freightKanzanShiteiDiv: '0'
      };
    }

    return {
      freightCursn: this.freightCurrency,
      freightKingaku: this.freightValue,
      freightKanzanShiteiDiv:
        this.freightCurrencyConversionMode === 'date' ? '0' : '1',
      freightKanzanDay: this.freightCurrencyDate,
      freightKanzanRitsu: this.freightCurrencyRate
    };
  }

  private set freightData(data) {
    this.freightCurrency = data.freightCursn;
    this.freightValue = data.freightKingaku;
    this.freightCurrencyConversionMode = data.freightKanzanShiteiDiv === '0' ? 'date' : 'rate';
    this.freightCurrencyDate = data.freightKanzanDay;
    this.freightCurrencyRate = data.freightKanzanRitsu;
  }

  private get policyData() {
    // If don't need to issue policy, only need one field
    if (this.policyType === '3') {
      return { shokenRuiDiv: this.policyType };
    }

    return {
      shokenHakkouDay: this.policyIssueDate || '',
      shokenRuiDiv: this.policyType,
      polCertHonshiMaisu: this.policyNumberOfOriginals.toString(),
      polCertUtsushiMaisu: this.policyNumberOfCopies.toString()
    };
  }

  private set policyData(data) {
    this.policyIssueDate = data.shokenHakkouDay;
    this.policyNumberOfOriginals = data.polCertHonshiMaisu ? Number(data.polCertHonshiMaisu) : 0;
    this.policyNumberOfCopies = data.polCertUtsushiMaisu ? Number(data.polCertUtsushiMaisu) : 0;
  }

  private get debitNoteData() {
    return {
      debitNoteNetHonshiMaisu: this.debitNoteNetNumberOfOriginals.toString(),
      debitNoteNetUtsushiMaisu: this.debitNoteNetNumberOfCopies.toString(),
      debitNoteGrossHonshiMaisu: this.debitNoteGrossNumberOfOriginals.toString(),
      debitNoteGrossUtsushiMaisu: this.debitNoteGrossNumberOfCopies.toString()
    };
  }

  private set debitNoteData(data) {
    this.debitNoteNetNumberOfOriginals = data.debitNoteNetHonshiMaisu
      ? Number(data.debitNoteNetHonshiMaisu) : 1;
    this.debitNoteNetNumberOfCopies = data.debitNoteNetUtsushiMaisu
      ? Number(data.debitNoteNetUtsushiMaisu) : 0;
    this.debitNoteGrossNumberOfOriginals = data.debitNoteGrossHonshiMaisu
      ? Number(data.debitNoteGrossHonshiMaisu) : 1;
    this.debitNoteGrossNumberOfCopies = data.debitNoteGrossUtsushiMaisu
      ? Number(data.debitNoteGrossUtsushiMaisu) : 0;
  }

  private get customsData() {
    return {
      kanzeiRitsu: this.tariffRate.toString(),
      kanzeiHokenKingakuCursn: this.customsInsuranceCurrency,
      kanzeiHokenKingaku: this.customsInsuranceAmount.toString()
    };
  }

  private set customsData(data) {
    this.tariffRate = data.kanzeiRitsu;
    this.customsInsuranceCurrency = data.kanzeiHokenKingakuCursn;
    this.customsInsuranceAmount = data.kanzeiHokenKingaku;
  }

  private get remarksData() {
    return {
      refCode1: this.refCodes[0],
      refCode2: this.refCodes[1],
      remarks1: this.remarks[0],
      remarks2: this.remarks[1],
      remarks3: this.remarks[2],
      remarks4: this.remarks[3],
      remarks5: this.remarks[4],
      sonotaTsushinJiko: this.otherMessage,
      lcHokenJokenShitei: this.lcConditions
    };
  }

  private set remarksData(data) {
    this.refCodes[0] = data.refCode1;
    this.refCodes[1] = data.refCode2;
    this.remarks[0] = data.remarks1;
    this.remarks[1] = data.remarks2;
    this.remarks[2] = data.remarks3;
    this.remarks[3] = data.remarks4;
    this.remarks[4] = data.remarks5;
    this.otherMessage = data.sonotaTsushinJiko;
    this.lcConditions = data.lcHokenJokenShitei;
  }

  private get allData() {
    const data = {
      ...this.extraInput,
      ...this.contractData,
      ...this.assuredData,
      ...this.routeData,
      ...this.departureSegmentData,
      ...this.arrivalSegmentData,
      ...this.cargoData,
      ...this.invoiceData,
      ...this.insuranceData,
      ...this.freightData,
      ...this.policyData,
      ...this.debitNoteData,
      ...this.customsData,
      ...this.remarksData
    };
    return data;
  }

  @Watch('allData', { immediate: true })
  private emitNewData() {
    this.$emit('input', this.allData);
  }

  public dataForSaving() {
    const data = {
      extraInput: JSON.stringify(this.extraInput),
      contractData: JSON.stringify(this.contractData),
      assuredData: JSON.stringify(this.assuredDataForSaving),
      routeData: JSON.stringify(this.routeDataForSaving),
      departureSegmentData: JSON.stringify(this.departureSegmentData),
      arrivalSegmentData: JSON.stringify(this.arrivalSegmentData),
      cargoData: JSON.stringify(this.cargoData),
      invoiceData: JSON.stringify(this.invoiceData),
      insuranceData: JSON.stringify(this.insuranceData),
      freightData: JSON.stringify(this.freightData),
      policyData: JSON.stringify(this.policyData),
      debitNoteData: JSON.stringify(this.debitNoteData),
      customsData: JSON.stringify(this.customsData),
      remarksData: JSON.stringify(this.remarksData)
    };
    return data;
  }

  public loadSavedData(savedData) {
    Object.keys(savedData).forEach(key => {
      const camelKey = this.snakeToCamel(key);
      this[camelKey] = savedData[key];
    });
  }

  private get contractOptions() {
    return this.contracts.map((contract) => {
      return {
        // tslint:disable-next-line max-line-length
        // eslint-disable-next-line no-irregular-whitespace
        label: `${contract.yushutsunyuDiv === '1' ? 'export' : 'import'} | ${contract.tsuuchiFormNo}　|　${contract.description}`,
        value: contract.tsuuchiFormNo
      };
    });
  }

  private async searchPlaces(
    searchText: string,
    callback: (items: { item: PlaceFields; value: string }[]) => void
  ) {
    const { data, loading } = await portService.fetchPorts(
      searchText,
      this.transportationType
    );
    if (!loading) {
      callback(data.places.map(this.generatePortOption));
    }
  }

  private generatePortOption(port: PlaceFields) {
    return {
      item: port,
      value: this.generatePortOptionLabel(port)
    };
  }

  private generatePortOptionLabel(port: PlaceFields): string {
    const code = `${port.countryCode}${port.code}`.toString();
    let i18nKey = 'ports.place-type.select-label.port';
    if (port.placeType === 'airport') {
      i18nKey = 'ports.place-type.select-label.airport';
    }

    return this.$t(i18nKey, { code, name: port.name }).toString();
  }

  private mainTransportationTypeOptions() {
    return [
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '14',
      '15'
    ].map((k) => {
      return { value: k, label: this.attyo[k] };
    });
  }

  private otherTransportationTypeOptions() {
    return ['01', '02', '03', '05', '11', '12', '13'].map((k) => {
      return { value: k, label: this.attyo[k] };
    });
  }

  private get attyo(): { [key: string]: TranslateResult } {
    return {
      '01': this.$t('insurance.transportation-types.sea'),
      '02': this.$t('insurance.transportation-types.air'),
      '03': this.$t('insurance.transportation-types.land'),
      '04': this.$t('insurance.transportation-types.courier'),
      '05': this.$t('insurance.transportation-types.barge'),
      '06': this.$t('insurance.transportation-types.hand-carry'),
      '07': this.$t('insurance.transportation-types.airmail-parcel'),
      '08': this.$t('insurance.transportation-types.seamail-parcel'),
      '09': this.$t('insurance.transportation-types.registered-airmail'),
      10: this.$t('insurance.transportation-types.other'),
      11: this.$t('insurance.transportation-types.train'),
      12: this.$t('insurance.transportation-types.truck'),
      13: this.$t('insurance.transportation-types.various'),
      14: this.$t('insurance.transportation-types.sea-and-air'),
      15: this.$t('insurance.transportation-types.air-and-sea')
    };
  }

  private get departurePlaceTypeOptions() {
    return ['1', '2', '3', '5', '6'].map((k) => {
      return { value: k, label: this.placeTypes[k] };
    });
  }

  private get arrivalPlaceTypeOptions() {
    return ['1', '2', '4', '5', '6'].map((k) => {
      return { value: k, label: this.placeTypes[k] };
    });
  }

  private get placeTypes(): { [key: string]: string } {
    return {
      1: 'INT.PLACE(S) IN',
      2: 'INT.POINT(S) IN',
      3: 'EX FACTORY IN',
      4: 'PLANT SITE(S) IN',
      5: 'INTERIOR PLACE(S) IN',
      6: 'INTERIOR POINT(S) IN'
    };
  }

  private get documentTypeOptions() {
    return [
      { value: '1', label: this.$t('insurance.document-type.awb') },
      { value: '2', label: this.$t('insurance.document-type.bl') },
      { value: '3', label: this.$t('insurance.document-type.contract') },
      { value: '4', label: this.$t('insurance.document-type.lc') },
      { value: '5', label: this.$t('insurance.document-type.other') }
    ];
  }

  private currencyOptions: { label: string; value: string }[] = [
    { label: 'JPY', value: '\\' },
    { label: 'USD', value: 'US$' },
    { label: 'CNY', value: 'RMB\\' },
    { label: 'EUR', value: 'EUR' },
    { label: 'AUD', value: 'A$' }
  ];

  private extraInput = {
    honsenigaiSenpaku: '',
    cifUpRitsu: '',
    sonotaCur: '',
    sectionNo1: '',
    sectionNo2: '',
    seikyuCd: '',
    shokenShutsuryokuBId: '01',
    meisaiShutsuryokuBId: '01',
    faxSoushin1SentakuFlg: '0',
    faxSoushin2SentakuFlg: '0',
    faxSoushin3SentakuFlg: '0',
    faxSoushin4SentakuFlg: '0',
    faxSoushin5SentakuFlg: '0',
    faxShurui1Sentaku: '',
    faxShurui2Sentaku: '',
    faxShurui3Sentaku: '',
    faxShurui4Sentaku: '',
    faxShurui5Sentaku: '',
    faxNo1: '',
    faxNo2: '',
    faxNo3: '',
    faxNo4: '',
    faxNo5: '',
    faxSoushinsaki1: '',
    faxSoushinsaki2: '',
    faxSoushinsaki3: '',
    faxSoushinsaki4: '',
    faxSoushinsaki5: '',
    yusosakiSentaku1Flg: ' ',
    yusosakiSentaku2Flg: ' ',
    shiteiShokenNo: ''
  };

  private snakeToCamel(str) {
    return str.replace(
      /([-_][a-z])/g,
      (group) => group.toUpperCase()
        .replace('-', '')
        .replace('_', '')
    );
  }
}
